<template>
    <div class="root">
        <transition style="position: relative" name="roll">
            <div class="formula-variables-container" v-if="visible" v-click-outside="onClickOutside">
                <div class="formula-variables-content">
                    <div style="display: flex; justify-content: space-between">
                        <input
                            type="text"
                            class="pattern-input"
                            v-model="patttern"
                            placeholder="Search Variables"
                        />
                        <div>
                            <a v-if="isShadow()" :href="newVariableLink()" target="_blank" style="margin-left: 5px;">
                                <button class="v2_btn v2_btn-primary v2_btn-transparent">
                                    New Variable
                                </button>
                            </a>
                        </div>
                    </div>
                    <div class="overflowing-list" style="height: 100%; padding-bottom: 48px;">
                        <div class="variable-list">
                            <div
                                class="variable-container"
                                v-bind:key="variable.id"
                                v-for="variable in filteredVariables"
                            >
                                <div class="variable-display">
                                    <div class="display-chip">
                                        <chip
                                            :label="dataTypeLabel(variable.data_type)"
                                            :color="dataTypeColor(variable.data_type)"
                                            :outlined="true"
                                        />
                                    </div>
                                    <div class="display-label">
                                        {{ variable.name }}
                                    </div>
                                </div>
                                <div class="variable-actions" title="copy variable">
                                    <i
                                        v-clipboard:copy="variable.name"
                                        v-clipboard:success="onCopy"
                                        class="fa fa-copy copy-action"
                                    />
                                    <a v-if="isShadow()" :href="editVariableLink(variable)" target="_blank" style="margin-left: 5px;" title="edit variable">
                                        <i class="fa fa-edit copy-action" />
                                    </a>
                                    <a v-if="!isShadow()" :href="viewVariableLink(variable)" target="_blank" style="margin-left: 5px;" title="view variable">
                                        <i class="fa fa-eye copy-action" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <button class="btn-floating" ref="fomulaBtn" @click="visible = !visible">Variables</button>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import VueClipboard from "vue-clipboard2";

import Chip from "../../utils/b-chip.vue";

Vue.use(VueClipboard);
Vue.directive("click-outside", {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = event => {
            if (
                !(
                    el === event.target ||
                    el.contains(event.target) ||
                    vnode.context.$refs.fomulaBtn.contains(event.target)
                )
            ) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});

export default {
    name: "FormulaVariables",
    components: {
        Chip,
    },
    props: {
        buttonClass: {
            default: "",
            required: false,
        },
    },
    data() {
        return {
            visible: false,
            patttern: "",
        };
    },
    methods: {
        onCopy: async function ($event) {
            //TODO show tooltip saying message has been copied
            console.log($event);
        },
        dataTypeLabel: function (dataType) {
            return dataType.charAt(0).toUpperCase() + dataType.slice(1);
        },
        dataTypeColor: function (dataType) {
            switch (dataType) {
                case "number":
                    return "#4caf50";
                case "boolean":
                    return "#ff9800";
                case "string":
                    return "#5cbbf6";
                case "lookup":
                    return "#f44336";
                default:
                    return "#e0e0e0";
            }
        },
        onClickOutside() {
            this.visible = false;
        },
        isShadow: function () {
            return this.pipelineSlug === 'shadow';
        },
        newVariableLink() {
            return `/manage/resources/shadow-variable/new?viaResource=shadow-formula&viaResourceId=${this.formula.id}&viaRelationship=FormulaVariables`;
        },
        editVariableLink(variable) {
            return `/manage/resources/${this.pipelineSlug}-variable/${variable.id}/edit?viaResource=${this.pipelineSlug}-formula&viaResourceId=${variable.formula_id}&viaRelationship=FormulaVariables`;
        },
        viewVariableLink(variable) {
            return `/manage/resources/${this.pipelineSlug}-variable/${variable.id}/?viaResource=${this.pipelineSlug}-formula&viaResourceId=${variable.formula_id}&viaRelationship=FormulaVariables`;
        },
    },
    computed: {
        ...mapGetters(["variables", "pipelineSlug", "formula"]),
        filteredVariables: function () {
            if (this.patttern === "") return this.variables;

            const pattern = this.patttern.toLowerCase();

            return this.variables.filter(v => (v.name + v.data_type).toLowerCase().indexOf(pattern) > -1);
        },
    },
};
</script>

<style scoped>
div.variable-container:before {
    content: "";
    position: absolute;
    left: 2%;
    bottom: 0;
    height: 1px;
    width: 98%;
    border-bottom: 1px solid #ececec;
}

.variable-container {
    justify-content: space-between;
    display: flex;
    align-items: center;
    font-family: "roboto";
    padding: 0 16px;
    position: relative;
}

.variable-list {
    overflow: scroll;
    height: 100%;
}

.variable-list div.variable-container:last-child:before {
    border-bottom: none;
}
.variable-list div.variable-container:last-child:after {
    height: 100px;
    position: absolute;
}

.variable-display {
    display: flex;
    align-items: center;
}
.display-label {
    font-size: 14px;
    width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.display-chip {
    min-width: 100px;
    display: flex;
    justify-content: center;
}

.copy-action {
    transition: all 0.15s ease-in-out;
    cursor: pointer;
    color: #b6bad3d4;
}
.copy-action:hover {
    transform: scale(1.025);
    color: #4e63ff;
}

.pattern-input {
    border: none;
    border-bottom: solid 1px grey;
    margin-bottom: 32px;
}

.pattern-input:hover {
    border-width: 2px;
    border-color: black;
}
.pattern-input:focus-visible {
    outline: none;
    border-bottom: solid 2px #4e63ff;
}

.roll-enter-active,
.roll-leave-active {
    transition: all 0.4s;
    max-height: 360px;
    opacity: 1;
}
.roll-enter,
.roll-leave-to {
    opacity: 0.4;
    max-height: 0px;
}

.formula-variables-container {
    z-index: 4;
    right: 0px;
    margin-right: calc(100% - 98%);
    bottom: 120%;
    width: 600px;
    height: 300px;
    overflow: hidden;
    position: absolute;
    border-radius: 4px;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px,
    rgb(0 0 0 / 12%) 0px 1px 8px 0px;
    background: white;
}

.formula-variables-content {
    padding: 16px;
    height: inherit;
}

.root {
    display: contents;
    position: relative;
}

.btn-floating {
    padding: 6px 12px;
    background-color: transparent;
    border: solid #4e63ff36 1px;
    color: rgba(51, 51, 51, 0.22);
}

.btn-floating:hover {
    z-index: 1;
    animation: pulse 0.3s;
    text-decoration: none;
    transform: scale(1.015);
    color: rgba(51, 51, 51);
    background-color: white;
    border: solid #4e63ffe8 1px;
}
</style>
